import { PriceTableRow } from 'modules/Products/types'
import { useNavigate } from 'react-router-dom'
import { ProductListPriceKebabMenu } from './ProductListPriceKebabMenu'
import {
  SequenceMenu,
  SetIsOpen,
  Td,
  Tr,
  Box,
  Flex
} from '@sequencehq/core-components'
import { ArchiveListPriceMenuItem } from 'Products/menuItems'
import { toBillingFrequencyLabel } from '@sequencehq/utils'
import { ProtectedComponent, usePermissions } from 'lib/rbac'

export const ProductListPrice = ({
  priceRow,
  productId,
  onDuplicate
}: {
  priceRow: PriceTableRow
  productId: string
  onDuplicate: (priceRow: PriceTableRow) => void
}) => {
  const navigate = useNavigate()
  const { can } = usePermissions()

  const priceRowFrequency = toBillingFrequencyLabel(priceRow.frequency)

  return (
    <Tr
      key={priceRow.id}
      onClick={() => {
        navigate(`/products/${productId}/list-price/${priceRow.id}`)
      }}
      data-testid={`product.listPrices.${priceRow.id}`}
    >
      <Td>{priceRow.unitPrice}</Td>
      <Td>{priceRow.name}</Td>
      <Td>{priceRow.currency}</Td>
      <Td>{priceRowFrequency}</Td>
      <Td>{priceRow.pricingModel}</Td>
      <Td>
        <Flex justify="space-between" align="center">
          {priceRow.created}
          <ProtectedComponent
            permission={['org.product:archive', 'org.product:create']}
          >
            <Box onClick={e => e.stopPropagation()} paddingLeft="8px">
              <ProductListPriceKebabMenu
                data-testid={`product.listPrices.${priceRow.id}.menu`}
                items={[
                  ...(can('org.product:create')
                    ? [
                        <SequenceMenu.Item
                          key="product-list-duplicate-menu-item"
                          uuid="duplicate"
                          label="Duplicate"
                          onClick={e => {
                            e.stopPropagation()
                            onDuplicate(priceRow)
                          }}
                        />
                      ]
                    : []),
                  ...(can('org.product:archive')
                    ? [
                        ({ setIsOpen }: { setIsOpen?: SetIsOpen }) => (
                          <ArchiveListPriceMenuItem
                            key="product-list-archive-menu-item"
                            listPriceId={priceRow.id}
                            onClose={() => setIsOpen?.(false)}
                            onSuccess={() => setIsOpen?.(false)}
                          />
                        )
                      ]
                    : [])
                ]}
              />
            </Box>
          </ProtectedComponent>
        </Flex>
      </Td>
    </Tr>
  )
}
